// extracted by mini-css-extract-plugin
module.exports = {"outlinedButton":"styles_outlinedButton__2blnL","cyan":"styles_cyan__1jmED","blue":"styles_blue__3btoW"};